"use client";

import React from "react";
import Image from "next/image";
import useTheme from "src/context/appThemeContext";
import { partners } from "src/utils/mock/homePageMock";

const ProcessStepsSection = ({ data, techIcons = [] }) => {
  const { theme, mounted } = useTheme();

  const { trustTitle = "TRUSTED BY BUSINESSES WORLDWIDE", trustClients = [] } = data || {};

  const row1 = partners.slice(0, 4);
  const row2 = partners.slice(4);
  const staticTechIcons = [
    { name: "Flutter", icon: "/images/icons/flutter.webp" },
    { name: "Dart", icon: "/images/icons/dart.webp" },
    { name: "Firebase", icon: "/images/icons/firebase.webp" },
    { name: "React Native", icon: "/images/icons/reactnative.webp" },
    { name: "SQLite", icon: "/images/icons/sqlite.webp" },
    { name: "NEXTJS", icon: "/images/icons/ns.png" },
    { name: "Ionic", icon: "/images/icons/ionic.webp" },
  ];

  const technologies = (techIcons?.length > 0 ? techIcons : staticTechIcons).slice(0, 7);
  return (
    <div
      className="mb-10! rounded-2xl border border-border-primary  backdrop-blur-md p-8! md:p-10! relative overflow-hidden"
      style={{
        background: "var(--card-background)",
        boxShadow: "var(--card-shadow)",
      }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-11 gap-10! lg:gap-12! items-stretch">
        {technologies?.length > 0 && (
          <div className="lg:col-span-6 flex flex-col justify-between">
            <div>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600 text-xs font-bold uppercase tracking-widest block mb-4!">
                Technology Behind the Product
              </span>

              <div className="grid grid-cols-3 sm:grid-cols-7 lg:grid-cols-6 xl:grid-cols-7  gap-4! sm:gap-3!  mt-8!">
                {technologies?.map((tech, index) => {
                  return (
                    <div key={index} className="flex flex-col items-center group cursor-pointer transition-transform duration-300 hover:scale-105">
                      <div className="flex h-16 w-16 items-center justify-center rounded-[10px] bg-surface-primary border border-border-primary shadow-sm transition-all duration-300 mb-3! relative">
                        <Image src={tech.icon} alt={tech.name} width={48} height={48} className="h-12 w-12" />
                      </div>
                      <span className="text-[11px] font-medium text-text-secondary group-hover:text-text-primary transition-colors tracking-wide text-center uppercase">
                        {tech.name}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <div className="hidden lg:block lg:col-span-1 w-[1px] bg-gradient-to-b from-transparent via-border-primary to-transparent self-stretch mx-auto!" />

        <div className="lg:col-span-4 flex flex-col justify-between">
          <div>
            {trustTitle && (
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 dark:from-purple-400 dark:to-pink-500 text-xs font-bold uppercase tracking-widest  mb-6!">
                {trustTitle}
              </span>
            )}

            <div className="flex flex-col gap-6! mt-6!">
              {row1.length > 0 && (
                <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-2 xl:grid-cols-4 gap-4! items-center justify-items-center">
                  {row1.map((client, idx) => (
                    <div
                      key={idx}
                      className="w-[90px] flex items-center justify-center rounded-[5px] border border-border-primary bg-surface-primary h-[50px] shadow-sm opacity-70 hover:opacity-100 transition-all"
                    >
                      <Image
                        src={mounted && theme === "dark" ? client.DarkImage : client.image}
                        alt={client.alt || "client logo"}
                        width={120}
                        height={30}
                        className="h-[40px] w-auto object-contain !px-2"
                      />
                    </div>
                  ))}
                </div>
              )}

              {row2.length > 0 && (
                <div className="grid grid-cols-2 gap-4! items-center justify-items-center max-w-[280px] w-full mx-auto!">
                  {row2.map((client, idx) => (
                    <div
                      key={idx}
                      className="w-full flex items-center justify-center rounded-[5px] border border-border-primary bg-surface-primary !px-2 !py-2 h-[40px] shadow-sm opacity-70 hover:opacity-100 transition-all"
                    >
                      <Image
                        src={mounted && theme === "dark" ? client.DarkImage : client.image}
                        alt={client.alt || "client logo"}
                        width={120}
                        height={30}
                        className="max-h-[25px] w-auto object-contain"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessStepsSection;
